/**
 * Protected Route Component
 * Ensures only authenticated users can access admin routes
 * Also checks for first login requirement
 */

import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../store/AuthContext';
import { apiService } from '../../services/apiService';
import { tokenManager } from '../../utils/tokenManager';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const [checkingFirstLogin, setCheckingFirstLogin] = useState(false);

  useEffect(() => {
    // If authenticated and has a token, check first login status
    if (isAuthenticated && tokenManager.isAuthenticated() && location.pathname !== '/first-login') {
      setCheckingFirstLogin(true);
      apiService.checkFirstLoginStatus()
        .then((status) => {
          if (status.requiresFirstLogin) {
            // First login required - will be handled by AuthContext redirect
          }
        })
        .catch((err) => {
          console.error('Failed to check first login status:', err);
        })
        .finally(() => {
          setCheckingFirstLogin(false);
        });
    }
  }, [isAuthenticated, location.pathname]);

  if (isLoading || checkingFirstLogin) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

